import React from 'react'

export const renderTextField = ({
  input,
  label,
  type,
  groupClassName,
  inputClassName,
  meta: { touched, error }
}) => (
  <div
    className={`equote-package-additional-details-form--input-group ${
      groupClassName ? groupClassName : ''
    }`}
    style={{ position: 'relative' }}
  >
    <input
      {...input}
      placeholder={label}
      type={type}
      className={inputClassName ? inputClassName : ''}
    />
    {touched &&
      (error && (
        <span
          className="u-remove-margin equote-package-additional-details-form--input-group--error"
          style={{ position: 'absolute', bottom: '-15px' }}
        >
          *{error}
        </span>
      ))}
  </div>
)

export const renderSelectField = ({
  label,
  input,
  options,
  groupClassName,
  meta: { touched, error }
}) => (
  <div
    className={`equote-package-additional-details-form--input-group-dropdown ${
      groupClassName ? groupClassName : ''
    }`}
    style={{ position: 'relative', zIndex: '2' }}
  >
    {/* <label className="equote-package-additional-details-form--input-group--label">
        {label}
      </label> */}
    <select {...input}>
      {options.map((option, i) => (
        <option key={option.value + i} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
    <span className="u-custom-select__arrow" />

    {touched &&
      (error && (
        <span className="u-remove-margin equote-package-additional-details-form--input-group--error">
          *{error}
        </span>
      ))}
  </div>
)

export const renderRadioButtonGroupField = ({
  label,
  options,
  input,
  displayFlex,
  question,
  meta: { touched, error }
}) => (
  <div className="equote-package-additional-details-form--input-group">
    <label className="equote-package-additional-details-form--input-group--label">
      {label}
    </label>
    <span>{question}</span>
    <div
      className={`u-package-forms-radio-group u-mobile-input ${
        displayFlex ? 'u-flex-container' : ''
      } `}
    >
      {options.map((option, i) => {
        return (
          <label
            key={option.value + i}
            className="u-package-forms-radio-group-label"
          >
            <input
              className="u-package-forms-radio-group-input radio"
              {...input}
              value={option.value}
              type={'radio'}
            />
            {option.label}
          </label>
        )
      })}
    </div>
    {touched &&
      (error && (
        <span className="u-remove-margin equote-package-additional-details-form--input-group--error">
          *{error}
        </span>
      ))}
  </div>
)
